import axios from "axios";
import { setHeader, TEST_API } from "./index";

const getFiles = async () => {
  return axios({
    method: "GET",
    url: `${TEST_API}/admin/logs/files`,
    headers: setHeader(),
  });
};

const getLogContent = async (filename, params = {}) => {
  return axios({
    method: "GET",
    url: `${TEST_API}/admin/logs/view/${filename}`,
    headers: setHeader(),
    params: params,
  });
};

const downloadLog = async (filename) => {
  return axios({
    method: "GET",
    url: `${TEST_API}/admin/logs/download/${filename}`,
    headers: setHeader(),
    responseType: 'blob',
  });
};

const getStatistics = async (filename) => {
  return axios({
    method: "GET",
    url: `${TEST_API}/admin/logs/statistics/${filename}`,
    headers: setHeader(),
  });
};

const getRecentErrors = async (limit = 50) => {
  return axios({
    method: "GET",
    url: `${TEST_API}/admin/logs/errors/recent`,
    headers: setHeader(),
    params: { limit },
  });
};

export default {
  getFiles,
  getLogContent,
  downloadLog,
  getStatistics,
  getRecentErrors,
};


